/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type loginOauth_viewer = {
    readonly id: string;
    readonly actualPersonId: string | null;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly " $refType": "loginOauth_viewer";
};
export type loginOauth_viewer$data = loginOauth_viewer;
export type loginOauth_viewer$key = {
    readonly " $data"?: loginOauth_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"loginOauth_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "loginOauth_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = 'e37fa190520dbb1d01c2dac353db01d0';
export default node;
